// extracted by mini-css-extract-plugin
module.exports = {"filterList":"SizeFilter_filterList__WZ83w","filterButton":"SizeFilter_filterButton__HksKW","autoSize":"SizeFilter_autoSize__KEBMo","selected":"SizeFilter_selected__KzFqR"};